(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceQuestionDialogController', RaceQuestionDialogController);

    RaceQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'RaceQuestion', 'Race', 'QuestionAnswer'];

    function RaceQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, RaceQuestion, Race, QuestionAnswer) {
        var vm = this;

        vm.raceQuestion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.races = Race.query({filter: 'racequestion-is-null'});
        $q.all([vm.raceQuestion.$promise, vm.races.$promise]).then(function() {
            if (!vm.raceQuestion.race || !vm.raceQuestion.race.id) {
                return $q.reject();
            }
            return Race.get({id : vm.raceQuestion.race.id}).$promise;
        }).then(function(race) {
            vm.races.push(race);
        });
        vm.questionanswers = QuestionAnswer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.raceQuestion.id !== null) {
                RaceQuestion.update(vm.raceQuestion, onSaveSuccess, onSaveError);
            } else {
                RaceQuestion.save(vm.raceQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:raceQuestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
